import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryOriginalVariationArgs, BackendVariation } from 'src/types/backend';

const QUERY = gql`
  query VariationOriginalText($id: ID!) {
    originalVariation(id: $id) {
      id
      acCopyText
      score
    }
  }
`;

type Variables = BackendQueryOriginalVariationArgs;
type Result = Pick<BackendVariation, 'acCopyText' | 'score'>;

export const queryVariationOriginal = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });

  const data = getSingleProp<Result>(result.data);
  if (!data) {
    return null;
  }
  return {
    text: data.acCopyText,
    score: data.score,
  };
};
